module.exports = __webpack_public_path__ + "static/qh_28.6fb18297.jpg";